/**
 * Nexora 品牌标识（与桌面端同源）。
 * - Web：public/favicon.svg（本组件 / 标签页）
 * - Desktop：electron/assets/app-icon.png|.ico、selection-fab.png 均由该 SVG 导出
 */

type NexoraLogoProps = {
  /** sm=顶栏，lg=登录页主视觉 */
  size?: "sm" | "lg";
};

export function NexoraLogo({ size = "sm" }: NexoraLogoProps) {
  const cls = size === "lg" ? "nexora-logo nexora-logo--lg" : "nexora-logo";
  return (
    <img
      className={cls}
      src="/favicon.svg"
      alt="Nexora"
      width={size === "lg" ? 88 : 40}
      height={size === "lg" ? 88 : 40}
    />
  );
}
